import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { ContingentBundle } from './model/contingent-bundle.model';
import { Action, createReducer, on } from '@ngrx/store';
import { ContingentBundleActions } from './contingent-bundle.actions';

export const contingentBundleFeatureKey = 'contingentBundle';

export const contingentBundleAdapter = createEntityAdapter<ContingentBundle>();

export interface State extends EntityState<ContingentBundle> {}

export const initialState: State = contingentBundleAdapter.getInitialState({});

const contingentBundleReducer = createReducer(
    initialState,
    on(ContingentBundleActions.loadContingentBundlesSuccess, (state, { contingentBundles }) => contingentBundleAdapter.addMany(contingentBundles, state))
);

export function reducer(state: State | undefined, action: Action) {
    return contingentBundleReducer(state, action);
}
